import { BaseService } from 'Common/BaseService';
import { Config } from 'Config';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { RESTApiAdapter } from '../Adapters/RESTApiAdapter';
import { SystemService } from './SystemService';
import { autoinject } from 'aurelia-framework';
import { StringHelper } from '../../Code/Helpers/StringHelper';

@autoinject
export class AuthService extends BaseService {

    protected session: any = null;

    constructor(restApiAdapter: RESTApiAdapter) {
        super(restApiAdapter);
        this.session = JSON.parse(localStorage[Config.TokenName()] || null);
    }

    public async LoginAsPublicUser(userLanguageSufix: string): Promise<boolean> {

        await SystemService.Instance.ClearCache_All();

        let body = {};
        body['LoginAsPublicUserParam'] = {
            "LanguageSufix": userLanguageSufix
        }

        let response = await this.restApiAdapter.Execute(body);
        if (await ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('status') && response['status'] == 'OK') {
            this.SetUserInfo(response['data']);
            return true;
        }
        return false;
    }

    public async Login(userName: string, password: string): Promise<Object> {

        await SystemService.Instance.ClearCache_All();

        let body = {};
        body['LoginParam'] = {
            "UserName": userName,
            "Password": password
        }

        let response = await this.restApiAdapter.Execute(body);
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('status') && response['status'] == 'OK') {
            if (ObjectHelper.ObjectIs(response['data']['Token']) && StringHelper.StringIs(response['data']['Token']))
                this.SetUserInfo(response['data']);
        }
        return response;
    }

    public async TwoFactorAuthenticationVerification(verificationGuid: string, code: string): Promise<Object> {
        let body = {};
        body['TwoFactorAuthenticationVerificationParam'] = {
            "VerificationGuid": verificationGuid,
            "Code": code
        }

        let response = await this.restApiAdapter.Execute(body);
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('status') && response['status'] == 'OK') {
            if (ObjectHelper.ObjectIs(response['data']['Token']) && StringHelper.StringIs(response['data']['Token']))
                this.SetUserInfo(response['data']);
        }
        return response;
    }

    private SetUserInfo(userInfo) {
        if (ObjectHelper.ObjectIs(userInfo)) {
            localStorage[Config.TokenName()] = JSON.stringify(userInfo);
            this.session = userInfo;
        }
    }

    public async AuthGoogle(token: string): Promise<Object> {
        const response: any = this.ReturnResponse(await this.restApiAdapter.ExecuteWithouContentProcessing("AuthGoogle", null, "?token=" + token));
        if (ObjectHelper.ObjectIs(response) && response.Status == 0 && ObjectHelper.ObjectIs(response.JsonData)) {
            this.SetUserInfo(response.JsonData);
        }
        return response;
    }

    public async ResetPwd(userName: string): Promise<Object> {
        return await this.ReturnResponse(await this.restApiAdapter.ExecuteWithouContentProcessing("PasswordReset", null, "?userName=" + userName));
    }

    public async PasswordResetConfirm(id: string): Promise<Object> {
        return await this.ReturnResponse(await this.restApiAdapter.ExecuteWithouContentProcessing("PasswordResetConfirm", null, "?id=" + id));
    }

    public async PasswordResetConfirmSave(id: string, newPassword: string, confirmPassword: string): Promise<Object> {
        return await this.ReturnResponse(await this.restApiAdapter.ExecuteWithouContentProcessing("PasswordResetConfirmSave", null, "?id=" + id + "&newPassword=" + newPassword + "&confirmPassword=" + confirmPassword));
    }

    private async ReturnResponse(response): Promise<Object> {
        console.log(1111, 'ReturnResponse', response)
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('statusCode') && response['statusCode'] == '200'
            && response.hasOwnProperty('responseType') && response['responseType'] == 'json') {
            console.log(1111, 'ReturnResponse', response.response)
            return JSON.parse(response.response);
        }
        return null;
    }

    public async Logout() {
        //let body = {};
        //body['LogoutParam'] = {};
        //let response = await this.restApiAdapter.Execute(body);
        localStorage.removeItem(Config.TokenName());
        this.session = null;
    }

    public IsUserLogged(): boolean {
        if (ObjectHelper.IsNullOrUndefined(this.session) || ObjectHelper.IsNullOrUndefined(localStorage[Config.TokenName()])) {
            //this.Logout();
            return false;
        }

        return true;
    }

    public GetUserInfo() {
        return this.session;
    }

    public SetOptimCallAgentLineNumber(data: any) {
        if (ObjectHelper.ObjectIs(this.session) && ObjectHelper.ObjectIs(data) && this.session.UserId * 1 == data.UserId * 1) {
            this.session['OptimCallAgentLineNumber'] = data.AgentLineNumber;
            let userInfo: any = JSON.parse(localStorage[Config.TokenName()]);
            userInfo.OptimCallAgentLineNumber = data.AgentLineNumber;
            localStorage[Config.TokenName()] = JSON.stringify(userInfo);
        }
    }

    public GetUserPhoneLineNumbers(): Array<string> {
        let res: Array<string> = [];
        if (ObjectHelper.ObjectIs(this.session) && ObjectHelper.ArrayIs(this.session.PhoneLineNumbers)) {
            res = this.session.PhoneLineNumbers.slice();
        }
        if (ObjectHelper.ObjectIs(this.session) && StringHelper.StringIs(this.session.OptimCallAgentLineNumber)) {
            res.push(this.session.OptimCallAgentLineNumber);
        }
        if (ObjectHelper.ArrayIs(res)) {
            return res;
        }
        return null;
    }

    public GetUserLocale() {
        let locale: string = 'en';
        let windwowNavigator: any = window.navigator;
        console.log(1111111, 'Locale', windwowNavigator.languages, windwowNavigator.language, windwowNavigator.userLanguage);
        let browserLanguage = windwowNavigator.languages && windwowNavigator.languages[0] || windwowNavigator.language || windwowNavigator.userLanguage;
        if (StringHelper.StringIs(browserLanguage)) {
            locale = browserLanguage.toLowerCase().substring(0, 2);
        }
        console.log(1111112, 'Locale', locale);
        if (ObjectHelper.ObjectIs(this.session) && this.session.hasOwnProperty('UserLanguage')) {
            if (this.session['UserLanguage'] == 'en-US') {
                locale = this.session['UserLanguage'];
            }
            else {
                locale = this.session['UserLanguage'].substring(0, 2);
            }
        }
        console.log(1111113, 'Locale', locale);
        return locale;
    }
}